export const checkTableRules = {
  checkPersonName: [
    { required: true, message: '验收人必填' },
    { min: 2, max: 10, message: '长度在 2 到 10 个字符' },
  ],
  checkDate: [{ required: true, message: '验收日期必填' }],
  checkDesc: [
    { required: true, message: '验收说明必填' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符' },
  ],
};
